/* eslint-disable max-len */
// @flow
// primary colors
export var cleanWhite = function cleanWhite(o
/*: ?number */
) {
  return !o ? '#ffffff' : "rgba(255, 255, 255, " + o + ")";
};
export var white = cleanWhite;
export var jetBlack = function jetBlack(o
/*: ?number */
) {
  return !o ? '#000000' : "rgba(0, 0, 0, " + o + ")";
};
export var black = jetBlack; // G: gray colors

export var paleGrey = function paleGrey(o
/*: ?number */
) {
  return !o ? '#fafafb' : "rgb(250,250,251, " + o + ")";
};
export var albasterGrey = function albasterGrey(o
/*: ?number */
) {
  return !o ? '#f6f6f6' : "rgba(246, 246, 246, " + o + ")";
};
export var g100 = albasterGrey;
export var g200 = function g200(o
/*: ?number */
) {
  return !o ? '#dfe4ed' : "rgba(223, 228, 237, " + o + ")";
};
export var paleBlue = g200; // deprecated

export var mercuryGrey = g200; // deprecated

export var silverGrey = function silverGrey(o
/*: ?number */
) {
  return !o ? '#d4d4d4' : "rgba(212, 212, 212, " + o + ")";
};
export var g300 = silverGrey;
export var daveGrey = function daveGrey(o
/*: ?number */
) {
  return !o ? '#828282' : "rgba(130, 130, 130, " + o + ")";
};
export var g400 = daveGrey;
export var blackGrey = function blackGrey(o
/*: ?number */
) {
  return !o ? '#333333' : "rgba(51, 51, 51, " + o + ")";
};
export var g500 = blackGrey;
export var darkGrey = function darkGrey(o
/*: ?number */
) {
  return !o ? '#141414' : "rgba(20, 20, 20, " + o + ")";
};
export var g600 = darkGrey; // deprecated
// BRAND COLORS
// shipa freight colors | orange colors

var shipaFreight100 = function shipaFreight100(o
/*: ?number */
) {
  return !o ? '#fac2b3' : "rgba(250, 194, 179, " + o + ")";
};

export var sf100 = shipaFreight100;

var shipaFreight200 = function shipaFreight200(o
/*: ?number */
) {
  return !o ? '#f6947a' : "rgba(246, 148, 122, " + o + ")";
};

export var sf200 = shipaFreight200;

var shipaFreight300 = function shipaFreight300(o
/*: ?number */
) {
  return !o ? '#f26741' : "rgba(242, 103, 65, " + o + ")";
};

export var sf300 = shipaFreight300;

var shipaFreight400 = function shipaFreight400(o
/*: ?number */
) {
  return !o ? '#ce5737' : "rgba(206, 87, 55, " + o + ")";
};

export var sf400 = shipaFreight400;
export var monaLisa = function monaLisa(o
/*: ?number */
) {
  return !o ? '#ffa38B' : "rgba(255, 163, 139, " + o + ")";
};
export var p100 = monaLisa; // deprecated

export var coral = function coral(o
/*: ?number */
) {
  return !o ? '#ff7e5d' : "rgba(255, 126, 93, " + o + ")";
};
export var p200 = coral; // deprecated

export var flamingo = function flamingo(o
/*: ?number */
) {
  return !o ? '#f26641' : "rgba(242, 102, 65, " + o + ")";
};
export var p300 = flamingo; // deprecated

export var cinnabar = function cinnabar(o
/*: ?number */
) {
  return !o ? '#e5461d' : "rgba(229, 70, 29, " + o + ")";
};
export var p400 = cinnabar; // deprecated
// shipa delivery | blue colors

var shipaDelivery100 = function shipaDelivery100(o
/*: ?number */
) {
  return !o ? '#9999ff' : "rgba(153, 153, 255, " + o + ")";
};

export var sd100 = shipaDelivery100;

var shipaDelivery200 = function shipaDelivery200(o
/*: ?number */
) {
  return !o ? '#4d4dff' : "rgba(77, 77, 255, " + o + ")";
};

export var sd200 = shipaDelivery200;

var shipaDelivery300 = function shipaDelivery300(o
/*: ?number */
) {
  return !o ? '#0000ff' : "rgba(0, 0, 255, " + o + ")";
};

export var sd300 = shipaDelivery300;

var shipaDelivery400 = function shipaDelivery400(o
/*: ?number */
) {
  return !o ? '#0000d9' : "rgba(0, 0, 217, " + o + ")";
};

export var sd400 = shipaDelivery400;
export var danubeBlue = function danubeBlue(o
/*: ?number */
) {
  return !o ? '#7499D0' : "rgba(116, 153, 208, " + o + ")";
};
export var c100 = danubeBlue; // deprecated

export var sanMarinoBlue = function sanMarinoBlue(o
/*: ?number */
) {
  return !o ? '#4773b3' : "rgba(71, 115, 179, " + o + ")";
};
export var c200 = sanMarinoBlue; // deprecated

export var topazBlue = function topazBlue(o
/*: ?number */
) {
  return !o ? '#295aa1' : "rgba(41, 90, 161, " + o + ")";
};
export var c300 = topazBlue; // deprecated

export var congressBlue = function congressBlue(o
/*: ?number */
) {
  return !o ? '#004594' : "rgba(0, 69, 148, " + o + ")";
};
export var c400 = congressBlue; // deprecated

export var mediumBlue = function mediumBlue(o
/*: ?number */
) {
  return !o ? '#2661a4' : "rgba(38, 97, 164, " + o + ")";
}; // deprecated

export var navy = function navy(o
/*: ?number */
) {
  return !o ? '#1b4473' : "rgba(27, 68, 115, " + o + ")";
}; // deprecated
// shipa ecommerce | green colors

var shipaEcommerce100 = function shipaEcommerce100(o
/*: ?number */
) {
  return !o ? '#abe7ad' : "rgba(171, 231, 173, " + o + ")";
};

export var se100 = shipaEcommerce100;

var shipaEcommerce200 = function shipaEcommerce200(o
/*: ?number */
) {
  return !o ? '#6bd670' : "rgba(107, 214, 112, " + o + ")";
};

export var se200 = shipaEcommerce200;

var shipaEcommerce300 = function shipaEcommerce300(o
/*: ?number */
) {
  return !o ? '#2cc433' : "rgba(44, 196, 51, " + o + ")";
};

export var se300 = shipaEcommerce300;
export var ecoGreen = se300; // for backward compatibility

export var b400 = se300; // for backward compatibility

var shipaEcommerce400 = function shipaEcommerce400(o
/*: ?number */
) {
  return !o ? '#25a72b' : "rgba(37, 167, 43, " + o + ")";
};

export var se400 = shipaEcommerce400;
export var meadowGreen = function meadowGreen(o
/*: ?number */
) {
  return !o ? '#0ec98c' : "rgba(14, 201, 140, " + o + ")";
};
export var b200 = meadowGreen; // deprecated

export var persianGreen = function persianGreen(o
/*: ?number */
) {
  return !o ? '#00b582' : "rgba(0, 181, 130, " + o + ")";
};
export var b300 = persianGreen; // deprecated
// shipa parcel

var shipaParcel100 = function shipaParcel100(o
/*: ?number */
) {
  return !o ? '#9ff2eb' : "rgba(159, 242, 235, " + o + ")";
};

export var sp100 = shipaParcel100;

var shipaParcel200 = function shipaParcel200(o
/*: ?number */
) {
  return !o ? '#57ccdb' : "rgba(87, 204, 219, " + o + ")";
};

export var sp200 = shipaParcel200;

var shipaParcel300 = function shipaParcel300(o
/*: ?number */
) {
  return !o ? '#0fb6cc' : "rgba(15, 182, 204, " + o + ")";
};

export var sp300 = shipaParcel300;

var shipaParcel400 = function shipaParcel400(o
/*: ?number */
) {
  return !o ? '#0d9bad' : "rgba(13, 155, 173, " + o + ")";
};

export var sp400 = shipaParcel400; // shipa mall

var shipaMall100 = function shipaMall100(o
/*: ?number */
) {
  return !o ? '#c3b4ff' : "rgba(195, 180, 255, " + o + ")";
};

export var sm100 = shipaMall100;

var shipaMall200 = function shipaMall200(o
/*: ?number */
) {
  return !o ? '#957cff' : "rgba(149, 124, 255, " + o + ")";
};

export var sm200 = shipaMall200;

var shipaMall300 = function shipaMall300(o
/*: ?number */
) {
  return !o ? '#6844ff' : "rgba(104, 68, 255, " + o + ")";
};

export var sm300 = shipaMall300;

var shipaMall400 = function shipaMall400(o
/*: ?number */
) {
  return !o ? '#583ad9' : "rgba(88, 58, 217, " + o + ")";
};

export var sm400 = shipaMall400; // secondary colors

export var secondaryBlue100 = function secondaryBlue100(o
/*: ?number */
) {
  return !o ? '#b9d9fd' : "rgba(185, 217, 253, " + o + ")";
};
export var secondaryBlue200 = function secondaryBlue200(o
/*: ?number */
) {
  return !o ? '#84b7f1' : "rgba(132, 183, 241, " + o + ")";
};
export var secondaryBlue300 = function secondaryBlue300(o
/*: ?number */
) {
  return !o ? '#5e9ee6' : "rgba(94, 158, 230, " + o + ")";
};
export var secondaryBlue400 = function secondaryBlue400(o
/*: ?number */
) {
  return !o ? '#3f84d0' : "rgba(63, 132, 208, " + o + ")";
};
export var secondaryCyan100 = function secondaryCyan100(o
/*: ?number */
) {
  return !o ? '#AAE4fb' : "rgba(170, 228, 251, " + o + ")";
};
export var secondaryCyan200 = function secondaryCyan200(o
/*: ?number */
) {
  return !o ? '#87d4f3' : "rgba(135, 212, 243, " + o + ")";
};
export var secondaryCyan300 = function secondaryCyan300(o
/*: ?number */
) {
  return !o ? '#5ec0e7' : "rgba(94, 192, 231, " + o + ")";
};
export var secondaryCyan400 = function secondaryCyan400(o
/*: ?number */
) {
  return !o ? '#3fa9d3' : "rgba(63, 169, 211, " + o + ")";
};
export var secondaryRed100 = function secondaryRed100(o
/*: ?number */
) {
  return !o ? '#ffe4e4' : "rgba(255, 228, 228, " + o + ")";
};
export var babyPink = secondaryRed100; // for backward compatibility

export var errorBg = secondaryRed100; // for backward compatibility

export var secondaryRed200 = function secondaryRed200(o
/*: ?number */
) {
  return !o ? '#fd9490' : "rgba(253, 148, 144, " + o + ")";
};
export var secondaryRed300 = function secondaryRed300(o
/*: ?number */
) {
  return !o ? '#fa605a' : "rgba(250, 96, 90, " + o + ")";
};
export var secondaryRed400 = function secondaryRed400(o
/*: ?number */
) {
  return !o ? '#de0000' : "rgba(222, 0, 0, " + o + ")";
};
export var errorRed = secondaryRed400; // for backward compatibility

export var errorText = secondaryRed400; // for backward compatibility

export var secondaryYellow100 = function secondaryYellow100(o
/*: ?number */
) {
  return !o ? '#ffe0BC' : "rgba(255, 224, 188, " + o + ")";
};
export var secondaryYellow200 = function secondaryYellow200(o
/*: ?number */
) {
  return !o ? '#ffc889' : "rgba(255, 200, 137, " + o + ")";
};
export var secondaryYellow300 = function secondaryYellow300(o
/*: ?number */
) {
  return !o ? '#f5ab56' : "rgba(245, 171, 86, " + o + ")";
};
export var secondaryYellow400 = function secondaryYellow400(o
/*: ?number */
) {
  return !o ? '#f99727' : "rgba(249, 151, 39, " + o + ")";
};
export var secondaryGreen100 = function secondaryGreen100(o
/*: ?number */
) {
  return !o ? '#c4f8cc' : "rgba(196, 248, 204, " + o + ")";
};
export var secondaryGreen200 = function secondaryGreen200(o
/*: ?number */
) {
  return !o ? '#93e8a1' : "rgba(147, 232, 161, " + o + ")";
};
export var secondaryGreen300 = function secondaryGreen300(o
/*: ?number */
) {
  return !o ? '#70d280' : "rgba(112, 210, 128, " + o + ")";
};
export var secondaryGreen400 = function secondaryGreen400(o
/*: ?number */
) {
  return !o ? '#44c058' : "rgba(68, 192, 88, " + o + ")";
}; // SHIPA MALL
// primary

export var smp900 = function smp900(o
/*: ?number */
) {
  return !o ? '#3C42AA' : "rgba(60, 66, 170, " + o + ")";
};
export var smp800 = function smp800(o
/*: ?number */
) {
  return !o ? '#555EF3' : "rgba(85, 94, 243, " + o + ")";
};
export var smp700 = function smp700(o
/*: ?number */
) {
  return !o ? '#6C73F5' : "rgba(108, 115, 245, " + o + ")";
};
export var smp600 = function smp600(o
/*: ?number */
) {
  return !o ? '#848AF6' : "rgba(132, 138, 246, " + o + ")";
};
export var smp500 = function smp500(o
/*: ?number */
) {
  return !o ? '#9DA1F8' : "rgba(157, 161, 248, " + o + ")";
};
export var smp400 = function smp400(o
/*: ?number */
) {
  return !o ? '#B5B9FA' : "rgba(181, 185, 250, " + o + ")";
};
export var smp300 = function smp300(o
/*: ?number */
) {
  return !o ? '#C2C5FB' : "rgba(194, 197, 251, " + o + ")";
};
export var smp200 = function smp200(o
/*: ?number */
) {
  return !o ? '#DADCFC' : "rgba(218, 220, 252, " + o + ")";
};
export var smp100 = function smp100(o
/*: ?number */
) {
  return !o ? '#E6E8FD' : "rgba(230, 232, 253, " + o + ")";
};
export var smp50 = function smp50(o
/*: ?number */
) {
  return !o ? '#F3F3FE' : "rgba(243, 243, 254, " + o + ")";
};
export var smp25 = function smp25(o
/*: ?number */
) {
  return !o ? '#FAFAFF' : "rgba(250, 250, 255, " + o + ")";
}; // secondary

export var sms900 = function sms900(o
/*: ?number */
) {
  return !o ? '#AB54C3' : "rgba(171, 84, 195, " + o + ")";
};
export var sms800 = function sms800(o
/*: ?number */
) {
  return !o ? '#BA5DF3' : "rgba(186, 93, 243, " + o + ")";
};
export var sms700 = function sms700(o
/*: ?number */
) {
  return !o ? '#C475F5' : "rgba(196, 117, 245, " + o + ")";
};
export var sms600 = function sms600(o
/*: ?number */
) {
  return !o ? '#D193F7' : "rgba(209, 147, 247, " + o + ")";
};
export var sms500 = function sms500(o
/*: ?number */
) {
  return !o ? '#D9A7F8' : "rgba(217, 167, 248, " + o + ")";
};
export var sms400 = function sms400(o
/*: ?number */
) {
  return !o ? '#E1BAFA' : "rgba(225, 186, 250, " + o + ")";
};
export var sms300 = function sms300(o
/*: ?number */
) {
  return !o ? '#EACEFB' : "rgba(234, 206, 251, " + o + ")";
};
export var sms200 = function sms200(o
/*: ?number */
) {
  return !o ? '#EED8FC' : "rgba(238, 216, 252, " + o + ")";
};
export var sms100 = function sms100(o
/*: ?number */
) {
  return !o ? '#F2E2FD' : "rgba(242, 226, 253, " + o + ")";
};
export var sms50 = function sms50(o
/*: ?number */
) {
  return !o ? '#F7EBFE' : "rgba(247, 235, 254, " + o + ")";
};
export var sms25 = function sms25(o
/*: ?number */
) {
  return !o ? '#FDF9FF' : "rgba(253, 249, 255, " + o + ")";
}; // neutral

export var neutralBlack = function neutralBlack(o
/*: ?number */
) {
  return !o ? '#000000' : "rgba(0, 0, 0, " + o + ")";
};
export var neutral900 = function neutral900(o
/*: ?number */
) {
  return !o ? '#1C1B1F' : "rgba(28, 27, 31, " + o + ")";
};
export var neutral800 = function neutral800(o
/*: ?number */
) {
  return !o ? '#313033' : "rgba(49, 48, 51, " + o + ")";
};
export var neutral700 = function neutral700(o
/*: ?number */
) {
  return !o ? '#484649' : "rgba(72, 70, 73, " + o + ")";
};
export var neutral600 = function neutral600(o
/*: ?number */
) {
  return !o ? '#787579' : "rgba(120, 117, 121, " + o + ")";
};
export var neutral500 = function neutral500(o
/*: ?number */
) {
  return !o ? '#939094' : "rgba(147, 144, 148, " + o + ")";
};
export var neutral400 = function neutral400(o
/*: ?number */
) {
  return !o ? '#AEAAAE' : "rgba(174, 170, 174, " + o + ")";
};
export var neutral300 = function neutral300(o
/*: ?number */
) {
  return !o ? '#C9C5CA' : "rgba(201, 197, 202, " + o + ")";
};
export var neutral200 = function neutral200(o
/*: ?number */
) {
  return !o ? '#E6E1E5' : "rgba(230, 225, 229, " + o + ")";
};
export var neutral100 = function neutral100(o
/*: ?number */
) {
  return !o ? '#F4EFF4' : "rgba(244, 239, 244, " + o + ")";
};
export var neutralWhite = function neutralWhite(o
/*: ?number */
) {
  return !o ? '#FFFFFF' : "rgba(255, 255, 255, " + o + ")";
}; // error

export var error900 = function error900(o
/*: ?number */
) {
  return !o ? '#410E0B' : "rgba(65, 14, 11, " + o + ")";
};
export var error800 = function error800(o
/*: ?number */
) {
  return !o ? '#601410' : "rgba(96, 20, 16, " + o + ")";
};
export var error700 = function error700(o
/*: ?number */
) {
  return !o ? '#8C1D18' : "rgba(140, 29, 24, " + o + ")";
};
export var error600 = function error600(o
/*: ?number */
) {
  return !o ? '#B3261E' : "rgba(179, 38, 30, " + o + ")";
};
export var error500 = function error500(o
/*: ?number */
) {
  return !o ? '#DC362E' : "rgba(220, 54, 46, " + o + ")";
};
export var error400 = function error400(o
/*: ?number */
) {
  return !o ? '#E46962' : "rgba(228, 105, 98, " + o + ")";
};
export var error300 = function error300(o
/*: ?number */
) {
  return !o ? '#EC928E' : "rgba(236, 146, 142, " + o + ")";
};
export var error200 = function error200(o
/*: ?number */
) {
  return !o ? '#F2B8B5' : "rgba(242, 184, 181, " + o + ")";
};
export var error100 = function error100(o
/*: ?number */
) {
  return !o ? '#F9DEDC' : "rgba(249, 222, 220, " + o + ")";
};
export var error50 = function error50(o
/*: ?number */
) {
  return !o ? '#FCEEEE' : "rgba(252, 238, 238, " + o + ")";
};
export var error25 = function error25(o
/*: ?number */
) {
  return !o ? '#FFFBF9' : "rgba(255, 251, 249, " + o + ")";
}; // warning

export var warn900 = function warn900(o
/*: ?number */
) {
  return !o ? '#E65100' : "rgba(230, 81, 0, " + o + ")";
};
export var warn800 = function warn800(o
/*: ?number */
) {
  return !o ? '#EF6C00' : "rgba(239, 108, 0, " + o + ")";
};
export var warn700 = function warn700(o
/*: ?number */
) {
  return !o ? '#F57C00' : "rgba(245, 124, 0, " + o + ")";
};
export var warn600 = function warn600(o
/*: ?number */
) {
  return !o ? '#FB8C00' : "rgba(251, 140, 0, " + o + ")";
};
export var warn500 = function warn500(o
/*: ?number */
) {
  return !o ? '#FF9800' : "rgba(255, 152, 0, " + o + ")";
};
export var warn400 = function warn400(o
/*: ?number */
) {
  return !o ? '#FFA726' : "rgba(255, 167, 38, " + o + ")";
};
export var warn300 = function warn300(o
/*: ?number */
) {
  return !o ? '#FFB74D' : "rgba(255, 183, 77, " + o + ")";
};
export var warn200 = function warn200(o
/*: ?number */
) {
  return !o ? '#FFCC80' : "rgba(255, 204, 128, " + o + ")";
};
export var warn100 = function warn100(o
/*: ?number */
) {
  return !o ? '#FFE0B2' : "rgba(255, 224, 178, " + o + ")";
};
export var warn50 = function warn50(o
/*: ?number */
) {
  return !o ? '#FFF3E0' : "rgba(255, 243, 224, " + o + ")";
};
export var warn25 = function warn25(o
/*: ?number */
) {
  return !o ? '#FBF7F0' : "rgba(251, 247, 240, " + o + ")";
}; // success

export var success900 = function success900(o
/*: ?number */
) {
  return !o ? '#33691E' : "rgba(51, 105, 30, " + o + ")";
};
export var success800 = function success800(o
/*: ?number */
) {
  return !o ? '#558B2F' : "rgba(85, 139, 47, " + o + ")";
};
export var success700 = function success700(o
/*: ?number */
) {
  return !o ? '#689F38' : "rgba(104, 159, 56, " + o + ")";
};
export var success600 = function success600(o
/*: ?number */
) {
  return !o ? '#7CB342' : "rgba(124, 179, 66, " + o + ")";
};
export var success500 = function success500(o
/*: ?number */
) {
  return !o ? '#8BC34A' : "rgba(139, 195, 74, " + o + ")";
};
export var success400 = function success400(o
/*: ?number */
) {
  return !o ? '#9CCC65' : "rgba(156, 204, 101, " + o + ")";
};
export var success300 = function success300(o
/*: ?number */
) {
  return !o ? '#AED581' : "rgba(174, 213, 129, " + o + ")";
};
export var success200 = function success200(o
/*: ?number */
) {
  return !o ? '#C5E1A5' : "rgba(197, 225, 165, " + o + ")";
};
export var success100 = function success100(o
/*: ?number */
) {
  return !o ? '#DCEDC8' : "rgba(220, 237, 200, " + o + ")";
};
export var success50 = function success50(o
/*: ?number */
) {
  return !o ? '#F1F8E9' : "rgba(241, 248, 233, " + o + ")";
};
export var success25 = function success25(o
/*: ?number */
) {
  return !o ? '#FCFCFA' : "rgba(252, 252, 250, " + o + ")";
}; // info

export var info900 = function info900(o
/*: ?number */
) {
  return !o ? '#0D47A1' : "rgba(13, 71, 161, " + o + ")";
};
export var info800 = function info800(o
/*: ?number */
) {
  return !o ? '#1565C0' : "rgba(21, 101, 192, " + o + ")";
};
export var info700 = function info700(o
/*: ?number */
) {
  return !o ? '#1976D2' : "rgba(25, 118, 210, " + o + ")";
};
export var info600 = function info600(o
/*: ?number */
) {
  return !o ? '#1E88E5' : "rgba(30, 136, 229, " + o + ")";
};
export var info500 = function info500(o
/*: ?number */
) {
  return !o ? '#2196F3' : "rgba(33, 150, 243, " + o + ")";
};
export var info400 = function info400(o
/*: ?number */
) {
  return !o ? '#42A5F5' : "rgba(66, 165, 245, " + o + ")";
};
export var info300 = function info300(o
/*: ?number */
) {
  return !o ? '#64B5F6' : "rgba(100, 181, 246, " + o + ")";
};
export var info200 = function info200(o
/*: ?number */
) {
  return !o ? '#90CAF9' : "rgba(144, 202, 249, " + o + ")";
};
export var info100 = function info100(o
/*: ?number */
) {
  return !o ? '#BBDEFB' : "rgba(187, 222, 251, " + o + ")";
};
export var info50 = function info50(o
/*: ?number */
) {
  return !o ? '#E3F2FD' : "rgba(227, 242, 253, " + o + ")";
};
export var info25 = function info25(o
/*: ?number */
) {
  return !o ? '#F7FCFF' : "rgba(247, 252, 255, " + o + ")";
}; // DEPRECATED yellow colors

export var goldenYellow = function goldenYellow(o
/*: ?number */
) {
  return !o ? '#ffc864' : "rgba(255, 200, 100, " + o + ")";
};
export var a200 = goldenYellow;
export var orangeYellow = function orangeYellow(o
/*: ?number */
) {
  return !o ? '#ffa600' : "rgba(255, 166, 0, " + o + ")";
};
export var a300 = orangeYellow; // DEPRECATED blue

export var pictonBlue = function pictonBlue(o
/*: ?number */
) {
  return !o ? '#4ecbe1' : "rgba(78, 203, 225, " + o + ")";
};
export var d200 = pictonBlue;
export var ceruleanBlue = function ceruleanBlue(o
/*: ?number */
) {
  return !o ? '#00badb' : "rgba(0, 186, 219, " + o + ")";
};
export var d300 = ceruleanBlue;